import SpotahomeLogo from './SpotahomeLogo';

export default SpotahomeLogo;
